import { Info } from '@mui/icons-material';
import { useMediaQuery, useTheme } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '~/components/button';
import { formatDate } from '~/lib/datetime';
import type { NetworkAuditLogs__AuditLog as AuditLog } from '../queries/list.generated';

export const useColumns = (handleOpenDialog: (row: AuditLog) => void): GridColDef<AuditLog>[] => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallAndUp = useMediaQuery(theme.breakpoints.up('sm'));

  return useMemo(
    () => [
      {
        field: 'createdAt',
        headerName: t('components.audit_logs.columns.date_time'),
        sortable: false,
        renderCell: ({ row }) => {
          return formatDate(row.createdAt);
        },
        flex: 0.3,
        minWidth: 220,
      },
      {
        field: 'userName',
        headerName: t('components.audit_logs.columns.user'),
        sortable: false,
        renderCell: ({ row }) => {
          return row.userName || t('components.audit_logs.columns.deleted_user');
        },
        flex: 0.3,
      },
      {
        field: 'actionName',
        headerName: t('common.labels.action'),
        sortable: false,
        flex: 0.2,
        minWidth: 140,
      },
      {
        field: 'actions',
        type: 'actions',
        align: 'right',
        minWidth: isSmallAndUp ? 24 : 0,
        getActions: ({ row }) => {
          return [
            <ActionButton
              key={`view-${row.id}`}
              title={t('common.labels.details')}
              Icon={Info}
              onClick={() => handleOpenDialog(row)}
            />,
          ];
        },
      },
    ],
    [isSmallAndUp, handleOpenDialog, t],
  );
};
